import { useMoveToGoods } from './moveToGoods';
import { useMoveToGoodsList } from './moveToGoodsList';
import { useMoveToRecentlyViewedGoods } from './moveToRecentlyViewedGoods';
import { moveToRankingGoods } from './moveToRankingGoods';

export const useGoodsNavigator = () => {
  const moveToGoods = useMoveToGoods();
  const moveToGoodsList = useMoveToGoodsList();
  const moveToRecentlyViewedGoods = useMoveToRecentlyViewedGoods();

  return {
    moveToGoods,
    moveToGoodsList,
    moveToRecentlyViewedGoods,
    moveToRankingGoods,
  };
};